import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'
import { CompanyExporterInformationDto, companyExporterInformationValidationSchema } from 'dtos'
import { LoadingButton } from '@mui/lab'

interface ExportInformationAddEditDialogProps {
  initialValues: CompanyExporterInformationDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function ExportInformationAddEditDialog({
  initialValues,
  loading,
  onClose,
  onSave,
  open
}: ExportInformationAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={false}
        validationSchema={companyExporterInformationValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Exporter Information</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.exporterDealerNumber && errors.exporterDealerNumber)}
                      helperText={touched.exporterDealerNumber && errors.exporterDealerNumber}
                      label='Dealer #'
                      name='exporterDealerNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.exporterDealerNumber}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.exporterDescription && errors.exporterDescription)}
                      helperText={touched.exporterDescription && errors.exporterDescription}
                      label='Description'
                      name='exporterDescription'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.exporterDescription}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.exporterIrsNumber && errors.exporterIrsNumber)}
                      helperText={touched.exporterIrsNumber && errors.exporterIrsNumber}
                      label='IRS #'
                      name='exporterIrsNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.exporterIrsNumber}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.exporterCode && errors.exporterCode)}
                      helperText={touched.exporterCode && errors.exporterCode}
                      label='Exporter Code'
                      name='exporterCode'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.exporterCode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>
                      ||All fields are required.|| Exporter Code must be 3 characters.||
                    </ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
